import React from 'react'
import parkingLocationPages from '../../../../config/parkingLocationPages'
import ProductSelect from './productSelect.jsx'

const ParkingSelect = ({id, label = 'Select your airport parking'}) => (
  <ProductSelect id={id} label={label} options={parkingLocationPages} />
)

export default ParkingSelect



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/dropdowns/parkingselect.jsx